var _line, _line2, _path, _path2, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddItem24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.75,
    x2: 10.5,
    y2: -0.75,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 16.5 11.25)",
    stroke: "current",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.75,
    x2: 10.5,
    y2: -0.75,
    transform: "matrix(-1 1.60275e-07 1.60275e-07 1 21 17.25)",
    stroke: "current",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.25C7.5 7.83579 7.16421 7.5 6.75 7.5C6.33579 7.5 6 7.83579 6 8.25C6 8.66421 6.33579 9 6.75 9C7.16421 9 7.5 8.66421 7.5 8.25Z",
    className: "filled",
    fill: "current",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 18.75L4.5 18.75L4.5 5.25L18.75 5.25L18.75 12.75L20.25 12.75L20.25 5.25C20.25 4.42157 19.5784 3.75 18.75 3.75L4.5 3.75C3.67157 3.75 3 4.42157 3 5.25L3 18.75C3 19.5784 3.67157 20.25 4.5 20.25L12 20.25L12 18.75Z",
    className: "filled",
    fill: "current",
    strokeWidth: 0
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 8.25,
    x2: 16.5,
    y2: 8.25,
    stroke: "current",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddItem24);
export default __webpack_public_path__ + "static/media/AddItem-24.d2567e47.svg";
export { ForwardRef as ReactComponent };